<h1 class="pt-0 dialog_confirm__title" mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  <p>{{ data.irreversible }}</p>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="data" color="primary" mat-button>{{'general.modal_ok_label'|translate}}</button>
  <button (click)="onNoClick()" cdkFocusInitial mat-button>{{'general.modal_cancel_label'|translate}}</button>
</div>
